const LoadingType = {
  LOADING_SHOW: 'LOADING_SHOW',
  LOADING_HIDE: 'LOADING_HIDE'
}

export default LoadingType;